import { useEffect, useState } from "react";

import {
  addKeyboardListener,
  type KeyboardListenerHandle,
} from "../../../NativeAdapters/keyboard.adapter";

export interface UseIsKeyboardOpenProps {
  keyboardOpenEvent?: "keyboardDidShow" | "keyboardWillShow";
}

export function useIsKeyboardOpen(props: UseIsKeyboardOpenProps = {}) {
  const { keyboardOpenEvent = "keyboardDidShow" } = props;

  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);

  useEffect(() => {
    const keyboardOpenEventListener: Promise<KeyboardListenerHandle> = addKeyboardListener(
      keyboardOpenEvent,
      () => {
        setIsKeyboardOpen(true);
      }
    );

    const keyboardDidHideListener = addKeyboardListener("keyboardDidHide", () => {
      setIsKeyboardOpen(false);
    });

    return () => {
      keyboardOpenEventListener
        // eslint-disable-next-line promise/prefer-await-to-then
        .then(async (listenerHandle) => {
          await listenerHandle.remove();
        })
        // eslint-disable-next-line promise/prefer-await-to-then
        .catch(() => {
          // Ignore errors
        });
      keyboardDidHideListener
        // eslint-disable-next-line promise/prefer-await-to-then
        .then(async (listenerHandle) => {
          await listenerHandle.remove();
        })
        // eslint-disable-next-line promise/prefer-await-to-then
        .catch(() => {
          // Ignore errors
        });
    };
  }, [keyboardOpenEvent]);

  return isKeyboardOpen;
}
